/**
 * Toggle Modal
 *
 * モーダルウィンドウの開閉
 *
 * @param {string} targetAttribute モーダルターゲットを指定するデータ属性名
 * ボタンに指定したカスタム属性の値をもとに、対応するモーダルウィンドウを開閉します。
 * モーダルウィンドウには `<dialog>` 要素を使用することを想定しています。
 */
export function toggleModal(targetAttribute) {
	// ボタンを取得（指定されたデータ属性を持つ要素をすべて選択）
	document.querySelectorAll(`[${targetAttribute}]`).forEach(button => {
		// ボタンにクリックイベントを設定
		button.addEventListener('click', () => {
			// ボタンのカスタム属性値からモーダルターゲットのIDを取得
			const targetId = button.getAttribute(targetAttribute);

			// 指定されたIDに対応するモーダルウィンドウを取得
			const targetElement = targetId && document.getElementById(targetId);

			// モーダルウィンドウが存在する場合に開閉処理を実行
			if (targetElement) {
				// モーダルが開いている場合は閉じる
				// 閉じている場合は開く
				targetElement.open ? targetElement.close() : targetElement.showModal();
			}
		});
	});
}
